import React from 'react';

// INTERFACES
import { ICol } from '../../interfaces/Grid.interface';

// STYLES
import { ColStyled } from './styles';

const Col: React.FC<ICol> = ({ children, justifyContent, lg, md, paddingLeft, paddingRight, overflowy, sm }: ICol) => {
  return (
    <ColStyled
      justifyContent={justifyContent}
      lg={lg}
      md={md}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
      overflowy={overflowy}
      sm={sm}
    >
      {children}
    </ColStyled>
  );
};

export default Col;
